{/* Build For Production */}
const env_constants = {
    API_BASE_URL: 'https://admin.autopartstation.com.au/api',
    API_BASE_PUBLIC_URL: 'https://admin.autopartstation.com.au/',
    FRONTEND_URL: 'https://autopartstation.com.au/',
    POPULAR_COUNT: 1,
    SCHEME_MARKUP: '12345',
    STORE_NAME: 'Auto Part Station',
    STORE_META_DESCRIPTION: 'Auto Part Station, an online plateform to buy and tools and products.',
    STORE_META_KEYWORDS: 'Auto Part Station, online plateform, tools and products',
    STORE_META_AUTHOR: 'Auto Part Station',
    STRIPE_PUBLIC_KEY: 'pk_live_51QZPo3CpbXmNIGvFgA9okpouXR1EwUMJgZuE6SjPzc6PwmPH5uU7ehTg7jzLWDhod1edbBNg7I01IskI2dqwLXMU00G3jxt9MK',
};

export default env_constants;


{/* Build For Development */}
{/* 

    const env_constants = {
    API_BASE_URL: 'https://dev.autopartstation.com.au/api',
    API_BASE_PUBLIC_URL: 'https://dev.autopartstation.com.au/',
    FRONTEND_URL: 'https://frontend-dev.autopartstation.com.au/',
    POPULAR_COUNT: 1,
    SCHEME_MARKUP: '12345',
    STORE_NAME: 'Auto Part Station',
    STORE_META_DESCRIPTION: 'Auto Part Station, an online plateform to buy and tools and products.',
    STORE_META_KEYWORDS: 'Auto Part Station, online plateform, tools and products',
    STORE_META_AUTHOR: 'Auto Part Station',
    STRIPE_PUBLIC_KEY: 'pk_test_51QZPo3CpbXmNIGvFygIwTC1oa9lZBSIK30wFEjmK81SqlDiQGVwXFWNmZLgeRC7ExUoyoFfd4JI1HJMCFtttytXO00UQPp3Yz0',
};

export default env_constants;

*/}